import moment from "moment-timezone";

export function formatRetreatDates(from?: string | null, to?: string | null): string {
  if (!from) return "Dates TBA";
  const start = moment(from).tz("America/New_York");
  if (!to || from === to || start.isSame(to, "day")) {
    return start.format("MMM D, YYYY");
  }
  const end = moment(to).tz("America/New_York");
  if (start.isSame(end, "month") && start.isSame(end, "year")) {
    return `${start.format("MMM D")} – ${end.format("D, YYYY")}`;
  }
  return `${start.format("MMM D")} – ${end.format("MMM D, YYYY")}`;
}

export function dateParts(from?: string | null): { month: string; day: string } {
  if (!from) return { month: "TBA", day: "—" };
  const start = moment(from).tz("America/New_York");
  if (!start.isValid()) return { month: "TBA", day: "—" };
  return { month: start.format("MMM"), day: start.format("D") };
}

export function capitalizeLabel(value?: string | null): string {
  if (!value) return "";
  return `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
}

export function greetingForHour(date = new Date()): string {
  const hour = moment(date).tz("America/New_York").hour();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
}

export function emptyKpis() {
  return {
    couplesActive: 0,
    couplesTotal: 0,
    registrationOpen: 0,
    inSetup: 0,
    closing: 0,
    projected: 0,
    completed: 0,
    waitlist: 0,
    openTickets: 0,
  };
}
